import { render } from "./FileButton.vue?vue&type=template&id=4f51c433&scoped=true"
import script from "./FileButton.vue?vue&type=script&lang=js"
export * from "./FileButton.vue?vue&type=script&lang=js"

import "./FileButton.vue?vue&type=style&index=0&id=4f51c433&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f51c433"]])

export default __exports__